module.exports = __webpack_public_path__ + "img/mascot-circle.cdc5575e.svg";